export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const REGION = 'REGION'

export const login = (session, language) => ({ type: LOGIN, session, language })

export const logout = () => ({ type: LOGOUT })

export const setRegion = region => ({ type: REGION, region })
